import { defineComponent as i, openBlock as o, createElementBlock as e, mergeProps as u, unref as n, renderSlot as g, createElementVNode as l, createCommentVNode as m } from "vue";
import { useScalarIcon as f } from "../hooks/useScalarIcon.js";
const k = { key: 0 }, A = { key: 1 }, Z = { key: 2 }, h = { key: 3 }, w = { key: 4 }, y = { key: 5 }, M = {
  name: "ScalarIconDot"
}, v = /* @__PURE__ */ i({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const d = s, { bind: a, weight: r } = f(d);
    return (p, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(a)), [
      g(p.$slots, "default"),
      n(r) === "bold" ? (o(), e("g", k, t[0] || (t[0] = [
        l("path", { d: "M144,128a16,16,0,1,1-16-16A16,16,0,0,1,144,128Z" }, null, -1)
      ]))) : n(r) === "duotone" ? (o(), e("g", A, t[1] || (t[1] = [
        l("path", {
          d: "M176,128a48,48,0,1,1-48-48A48,48,0,0,1,176,128Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Z" }, null, -1)
      ]))) : n(r) === "fill" ? (o(), e("g", Z, t[2] || (t[2] = [
        l("path", { d: "M128,80a48,48,0,1,0,48,48A48,48,0,0,0,128,80Zm0,60a12,12,0,1,1,12-12A12,12,0,0,1,128,140Z" }, null, -1)
      ]))) : n(r) === "light" ? (o(), e("g", h, t[3] || (t[3] = [
        l("path", { d: "M138,128a10,10,0,1,1-10-10A10,10,0,0,1,138,128Z" }, null, -1)
      ]))) : n(r) === "regular" ? (o(), e("g", w, t[4] || (t[4] = [
        l("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Z" }, null, -1)
      ]))) : n(r) === "thin" ? (o(), e("g", y, t[5] || (t[5] = [
        l("path", { d: "M136,128a8,8,0,1,1-8-8A8,8,0,0,1,136,128Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  v as default
};
